module.exports = __webpack_public_path__ + "img/logo-footer-resgistro-civil.283a197b.svg";